function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".arrow_download_svg__cls-1{fill:#19496b}"));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "arrow_download_svg__Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "arrow_download_svg__Capa_1",
  "data-name": "Capa 1"
}, React.createElement("rect", {
  className: "arrow_download_svg__cls-1",
  y: 140.52,
  width: 152.98,
  height: 28.56,
  rx: 14.28,
  ry: 14.28
}), React.createElement("path", {
  className: "arrow_download_svg__cls-1",
  d: "M137 73.43q-24.66 24.83-49.5 49.49c-7 7-15 7-22 0Q40.68 98.26 16 73.45c-6.41-6.45-6.75-15-1-20.92 6-6.15 14.48-5.9 21.25.79C44.6 61.59 52.87 70 62.14 79.26v-.79a14.38 14.38 0 01-.09-1.62V14.44a14.44 14.44 0 0128.88 0v62.41a13.93 13.93 0 01-.07 1.45 43.21 43.21 0 003.46-2.74c7.45-7.4 14.82-14.87 22.3-22.24 6.76-6.65 15.36-6.94 21.3-.84s5.54 14.42-.92 20.95z"
})));

var SvgArrowDownload = function SvgArrowDownload(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 152.98 169.09"
  }, props), _ref, _ref2);
};

export default SvgArrowDownload;